import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/creation_camp',
  component: Layout,
  redirect: '/creation_camp',
  name: 'creation_camp',
  meta: {
    title: '创造营',
    icon: 'welfare',
  },
  children: [

    {
        path: 'index',
        name: 'creationCampIndex',
        component: () => import('@/views/creation_camp/index.vue'),
        meta: {
            title: '合同管理',
            breadcrumb: true,
            auth: [
                'Business.CreationCamp.menu'
            ]
        }
    },
    {
      path: 'detail/:id',
      name: 'creationCampDetail',
      component: () => import('@/views/creation_camp/detail.vue'),
      meta: {
        title: '合同详情',
        menu: false,
        activeMenu: '/creation_camp/index',
        auth: [
            'Business.CreationCamp.menu'
        ]
      },
    },
    // {
    //     path: 'recharge',
    //     name: 'rechargeIndex',
    //     component: () => import('@/views/task/recharge.vue'),
    //     meta: {
    //         title: '账户充值',
    //         breadcrumb: true,
    //         auth: [
    //             'Task.Recharge.menu'
    //         ]
    //     }
    // },
    {
        path: 'recharge/detail/:order_no',
        name: 'rechargeDetail',
        component: () => import('@/views/task/recharge_order.vue'),
        meta: {
            title: '充值详情',
            menu: false,
            activeMenu: '/creation_camp/recharge',
            auth: [
                'Task.Task.menu'
            ]
        }
    },
    {
        path: 'task',
        name: 'taskIndex',
        component: () => import('@/views/task/index.vue'),
        meta: {
            title: '任务管理',
            breadcrumb: true,
            auth: [
                'Task.Task.menu'
            ]
        }
    },
    // {
    //     path: 'fund_flow',
    //     name: 'fundFlowIndex',
    //     component: () => import('@/views/task/fund_flow.vue'),
    //     meta: {
    //         title: '资金流水',
    //         breadcrumb: true,
    //         auth: [
    //             'Task.FundFlow.menu'
    //         ]
    //     }
    //   },
    {
        path: 'withdraw/list',
        name: 'withdrawList',
        component: () => import('@/views/task/withdraw.vue'),
        meta: {
            title: '提现管理',
            menu: false,
            activeMenu: '/creation_camp/fund_flow',
            auth: [
                'Task.Task.menu'
            ]
        }
    },
  ],
}

export default routes
